goog.provide("shadow.js.shim.module$node_stream$default");
shadow.js.shim.module$node_stream$default = esm_import$node_stream.default;
